<template>
    <span class="text-danger" v-if="mostrarMsgErroComprometimento">
        <strong
            >ENTREGA NÃO COMPROMETIDA. REGULARIZE A SITUAÇÃO PARA REALIZAR A
            APROVAÇÃO.
        </strong>
    </span>
</template>

<script>
export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        mostrarMsgErroComprometimento() {
            let retorno =
                this.$temAcesso('CRED-GEST-ENTR-01') &&
                this.entrega.status === 1 &&
                this.entrega.statusIdRm !== 1
            return retorno
        }
    }
}
</script>
